import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TrackingObjectBuilder } from './tracking-object.builder';

@NgModule({
  imports: [CommonModule],
})
export class TrackingModule {
  static forRoot(): ModuleWithProviders<TrackingModule> {
    return {
      ngModule: TrackingModule,
      providers: [TrackingObjectBuilder],
    };
  }
}
